import { render, staticRenderFns } from "./BaseSnackbar.vue?vue&type=template&id=6d25df19&scoped=true"
import script from "./BaseSnackbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseSnackbar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BaseSnackbar.vue?vue&type=style&index=0&id=6d25df19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d25df19",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseText: require('/home/runner/work/jafolders-web-customer/jafolders-web-customer/components/atoms/BaseText.vue').default})
